import React from 'react';
import { Search } from 'lucide-react';

export const SearchBar = ({ searchQuery, onSearchChange }) => {
  return (
    <div className="relative" data-testid="search-bar">
      <Search 
        className="absolute left-0 top-1/2 -translate-y-1/2 text-gray-400 w-5 h-5 md:w-6 md:h-6" 
        strokeWidth={1.5}
      />
      <input
        type="text"
        placeholder="Search news..."
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
        className="search-input pl-8 md:pl-10"
        data-testid="search-input"
      />
    </div>
  );
};

export default SearchBar;
